// This is being used for the add comment modal
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content"]

  connect() {
    // Listen for the custom event dispatched when a comment is successfully created
    document.addEventListener("comment:created", this.handleCommentCreated.bind(this));
    // Listen for form submissions
    document.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this), true);
  }

  disconnect() {
    document.removeEventListener("comment:created", this.handleCommentCreated.bind(this));
    document.removeEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this), true);
  }

  handleCommentCreated() {
    // Close the modal when a comment is successfully created
    this.close();
  }

  handleSubmitEnd(event) {
    // Only handle successful submissions
    if (!event.detail.success) return;
    
    // Check if the form is inside our modal's content area
    const form = event.target.closest("form");
    if (!form) return;
    
    // Check if form is within the add comment modal content
    const contentArea = document.getElementById("add_comment_modal_content");
    if (!contentArea || !contentArea.contains(form)) return;
    
    // Wait for Turbo Stream to process the response and update the DOM
    setTimeout(() => {
      this.checkAndClose();
    }, 300);
  }

  checkAndClose() {
    // Check if content was updated with a fresh form (successful submission)
    const contentArea = document.getElementById("add_comment_modal_content");
    if (!contentArea) return;
    
    const form = contentArea.querySelector("form");
    const hasErrors = contentArea.querySelector(".text-red-600");
    const modal = document.querySelector('[data-add-comment-modal-target="modal"]');
    
    // If there's a form, no errors, and modal is visible, it's a successful submission
    if (form && !hasErrors && modal && !modal.classList.contains("hidden")) {
      // Check if textarea is empty (fresh form after successful submission)
      const textarea = form.querySelector("textarea");
      if (textarea && !textarea.value.trim()) {
        // Successful submission - close the modal
        this.close();
      }
    }
  }

  open(event) {
    event.preventDefault();
    
    // Show modal overlay
    if (this.hasModalTarget) this.modalTarget.classList.remove("hidden");
    
    // Load the form content
    const objectType = this.element.dataset.objectType;
    const objectId = this.element.dataset.objectId;
    const url = `/comments/new_modal?object_type=${objectType}&object_id=${objectId}`;
    
    // Fetch and load content
    fetch(url)
      .then(response => response.text())
      .then(html => {
        if (this.hasContentTarget) {
          this.contentTarget.innerHTML = html;
        }
      })
      .catch(error => {
        console.error("Error loading comment form:", error);
        if (this.hasContentTarget) {
          this.contentTarget.innerHTML = "<p class='text-red-600'>Error loading comment form</p>";
        }
      });
  }

  close(event) {
    if (event) event.preventDefault();
    if (this.hasModalTarget) this.modalTarget.classList.add("hidden");
    // Clear content
    if (this.hasContentTarget) {
      this.contentTarget.innerHTML = "";
    }
  }
}

